<template>
  <van-popup v-model:show="visible"  position="center" :overlay="true" :closeable="true" :close-on-click-overlay="false"
    round
    :style="{ width: '85%', maxWidth: '560px', background: 'linear-gradient(180deg, #D8E0FF 0%, #FFFFFF 100%)', borderRadius: '24px' }">
    <div class="version-update-dialog">

      <div v-if="false">
        <!-- 版本更新标题 -->
        <div class="version-title">Your account</div>

        <!-- 更新内容卡片 -->
        <div class="p-10px bg-#fff rounded-16px mb-10px">
          <div class="flex items-center justify-between">
            <div>
              <div class="text-15px color-#242633">{{ info.nickname }}</div>
              <div class="text-12px color-#7C7D85 py-5px">ID:{{ info.userId }}</div>
            </div>
            <div class="bg-#F3F3F3  rounded-20px pr-16px pl-5px py-3px flex items-center justify-center">
              <div class="w-16px h-16px flex items-center justify-center">
                <img class="w-full h-full" src="@/assets/images/message/crystal.svg"></img>
              </div>
              <div>
                <div class="text-12px color-#242633">{{ balance }}</div>
              </div>
            </div>
          </div>
          <div class="text-12px color-#7C7D85" v-if="info.email">
            <span class="color-#242633">Email:</span> {{ info.email }}
          </div>
          <div class="text-12px color-#7C7D85  flex items-center justify-between" v-else>
            <div class="color-#242633">Email:</div>
            <div
              class="color-#5A68FF border-1px border-#5A68FF flex items-center justify-center rounded-10px px-5px py-0px bind-email-box"
              @click="handleBindEmail">Bind email > </div>
          </div>
          <div class="w-100% h-1px bg-#E5E7EB mb-10px mt-5px"></div>
          <div class="flex items-center justify-center">
            <div class="w-20px mr-5px flex-shrink-0 items-center justify-center">
              <img class="w-full h-full" src="@/assets/images/other/dui.svg" v-if="info.email"></img>
              <img class="w-full h-full" src="@/assets/images/other/warning.svg" v-else></img>
            </div>
            <div class="text-12px color-#11AA66 lh-16px mt-5px" v-if="info.email">
              After updating, please log in using your email account to avoid losing account data.
            </div>
            <div class="text-12px color-#FF9301 lh-16px mt-5px" v-else>
              Please bind your email to ensure the security of your account data.
            </div>
          </div>
        </div>
      </div>

      <!-- 版本更新标题 -->
      <div class="version-title">Version update</div>

      <!-- 更新内容卡片 -->
      <div class="update-content-card">
        <div class="content-title">Update content</div>
        <div class="content-list">
          <div v-for="(item, index) in updateContent" :key="index" class="content-item">
            {{ item }}
          </div>
        </div>
        <!-- 更新按钮 -->
        <div class="update-actions">
          <van-button class="update-btn" @click="handleUpdate" :loading="isUpdating">
            {{ updateButtonText }}
          </van-button>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import bridge from '@/utils/bridge'

import { showLoadingToast } from '@/utils/toast'
import { ref, watch, computed } from 'vue'
import { useUserStore } from '@/stores/user'
import { useRouter } from 'vue-router'
const userStore = useUserStore()
const router = useRouter()
const balance = computed(() => userStore.getMsgCost())
const info = computed(() => userStore.getTouristInfo())
// console.log(info,'info');

interface Props {
  modelValue?: boolean
  show?: boolean
  nickname?: string
  userId?: string
  email?: string
  updateContent?: string[]
  updateButtonText?: string
  showLoginTip?: boolean
  updateUrl?: string // 更新链接
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void
  (e: 'update:show', value: boolean): void
  (e: 'update'): void
  (e: 'close'): void
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: true,
  show: true,
  nickname: 'Nickname',
  userId: '12345678',
  email: 'user@example.com',
  updateContent: () => [
    'Client experience optimization',
    'Fix known BUG issues'
  ],
  updateButtonText: 'Update now',
  showLoginTip: true,
  updateUrl: ''
})

const emit = defineEmits<Emits>()

const handleBindEmail = () => {
  router.push({ name: 'Login', query: { isRegisterUrl: 'true', isSignInUrl: 'false', isLoginUrl: 'true' } })
  visible.value = false
}

// 统一的内部可见性状态，兼容 v-model 与 v-model:show
const visible = ref<boolean>(
  typeof props.show === 'boolean' ? !!props.show : !!props.modelValue
)
const isUpdating = ref(false)

// 同步外部传入的两种可见性来源
watch(() => props.modelValue, (val) => {
  if (val !== undefined) visible.value = val
})
watch(() => props.show, (val) => {
  if (val !== undefined) visible.value = !!val
})

watch(visible, (val) => {
  // 同时派发两种事件，兼容父组件使用 v-model 或 v-model:show
  emit('update:modelValue', val)
  emit('update:show', val)
  if (!val) emit('close')
})

const handleUpdate = () => {
  showLoadingToast('Updating...', { duration: 2000 })
  indexedDB.deleteDatabase('ChatRecordsDB')
  indexedDB.deleteDatabase('RoleplayH5')

  setTimeout(() => {
    window.location.reload()
  }, 2000)
}


// const handleClose = () => {
//   visible.value = false
//   emit('close')
// }

</script>

<style scoped lang="scss">
.version-update-dialog {
  padding: 32px 10px 24px;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 99;
}

.close-icon {
  width: 24px;
  height: 24px;
}

.dialog-title {
  font-weight: 900;
  font-size: 22px;
  font-style: italic;
  color: #01031B;
  margin-bottom: 24px;
  text-align: center;
  line-height: 1.2;
}

.user-info-card {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 10px 15px;
  margin-bottom: 12px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.user-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.user-label {
  font-weight: 700;
  font-size: 15px;
  color: #01031B;
}

.user-balance {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #F3F4F6;
  padding: 0px 16px;
  padding-left: 6px;
  border-radius: 20px;
}

.crystal-icon {
  width: 16px;
  height: 16px;
}

.balance-text {
  font-weight: 600;
  font-size: 16px;
  color: #01031B;
}

.user-id {
  font-weight: 500;
  font-size: 14px;
  color: #9CA3AF;
  // margin-bottom: 8px;
}

.user-email {
  font-weight: 500;
  font-size: 14px;
  color: #9CA3AF;
  padding-bottom: 8px;
  border-bottom: 1px solid #E5E7EB;
  margin-bottom: 4px;
}

.tip-box {
  display: flex;
  align-items: center;
  gap: 6px;
  // padding: 12px 2px;
  // background: #F0FDF4;
  border-radius: 12px;
  // border: 1px solid #D1FAE5;
}

.tip-text {
  flex: 1;
  // font-weight: 500;
  font-size: 12px;
  color: #10B981;
  // line-height: 1.5;
}

.version-title {
  font-weight: 900;
  font-size: 22px;
  font-style: italic;
  color: #01031B;
  margin-bottom: 12px;
  text-align: center;
  line-height: 1.2;
}

.update-content-card {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 24px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.content-title {
  font-weight: 700;
  font-size: 18px;
  color: #01031B;
  margin-bottom: 6px;
}

.content-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.content-item {
  font-weight: 500;
  font-size: 15px;
  color: #6B7280;
  line-height: 1.6;
  position: relative;
  padding-left: 0;
}

.update-actions {
  width: 100%;
}

.update-btn {
  margin-top: 40px;
  width: 100%;
  height: 50px;
  border-radius: 27px;
  background: linear-gradient(135deg, #667EEA 0%, #95A5FF 100%);
  border: none;
  font-weight: 700;
  font-size: 17px;
  color: #FFFFFF;
  letter-spacing: 0.5px;
  // box-shadow: 0 4px 16px rgba(102,  126, 234, 0.4);
  transition: all 0.3s ease;

  &:active:not(:disabled) {
    transform: scale(0.98);
    // box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

:deep(.van-button--loading) {
  opacity: 0.7;
}

:deep(.van-popup__close-icon) {
  color: #999;
  font-size: 22px;
  top: 16px;
  right: 16px;
}

.email-text {
  // cursor: pointer;
  border: 1px solid #5A68FF;
  border-radius: 10px;
  padding: 0px 10px;
}

.bind-email-box {
  border: 1px solid #5A68FF;
  border-radius: 15px;
  font-size: 12px;
}
</style>
